import { gql, useMutation } from '@apollo/client'
import type { GQL_ID } from '@@partner:types:graphql'

export interface TranslationInput {
  language_code: string
  name?: string
}

export interface RegionInput {
  id?: GQL_ID
  name: string
  country_id: GQL_ID
  i18n?: TranslationInput[]
}

export interface RegionTranslation {
  language_code: string
  name?: string
}

export interface Region {
  id: GQL_ID
  name: string
  country_id: GQL_ID
  i18n?: RegionTranslation[]
}

export interface SaveRegionMutation {
  saveRegion: Region
}

export interface SaveRegionVariables {
  regionInput: RegionInput
  upsert?: boolean
}

export const GQL_MUTATION_SAVE_REGION = gql`
  mutation saveRegion($regionInput: RegionInput!, $upsert: Boolean) {
    saveRegion(regionInput: $regionInput, upsert: $upsert) {
      id
      name
      country_id
      i18n {
        language_code
        name
      }
    }
  }
`

export const useSaveRegion = () =>
  useMutation<SaveRegionMutation, SaveRegionVariables>(GQL_MUTATION_SAVE_REGION)
